import { Route, Routes } from 'react-router-dom';
import RdcList from './rdc-list';
import RdcOverview from './rdc-overview/rdc-overview';

const RdcRouting = () => {
  return (
    <Routes>
      <Route path='' element={<RdcList />} />
      <Route path=':uid' element={<RdcOverview />} />
    </Routes>
  );
};

export default RdcRouting;
